import { FaPlus, FaWhatsapp, FaCheck } from "react-icons/fa6";
import { ModalWraper } from "../../../../../../components/modal/wraper";
import { useState, useEffect } from "react";
import { WaDeviceService } from "../../../../../../services/WaDeviceService";

export const AddNewDeviceModal = ({ openModal, setOpenModal, refreshData }) => {
    const [loading, setLoading] = useState(false);
    
    const [deviceForm, setDeviceForm] = useState({
        name: "",
        primary: false,
        phone_number: "",
        // urlwebhook dihapus karena tidak ada di backend store() tadi
    });

    // Reset form setiap kali modal dibuka
    useEffect(() => {
        if (openModal) {
            setDeviceForm({ name: "", primary: false, phone_number: "" });
        }
    }, [openModal]);

    const handleAddDevice = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Payload sesuai dengan request->validate di backend
        const payload = {
            name: deviceForm.name,
            primary: deviceForm.primary, // Pastikan boolean
            phone_number: deviceForm.phone_number,
        };

        try {
            const response = await WaDeviceService.create({ data: payload });

            if (response.data.status) {
                // Opsional: Gunakan toast notification jika ada, selain alert
                alert(response.data.message || "Device berhasil ditambahkan!");
                
                setOpenModal(false);
                refreshData();
            } else {
                alert(response.data.message || "Gagal menambahkan device.");
            }
        } catch (error) {
            console.error("Error create device:", error);
            let errorMessage = "Terjadi kesalahan pada server.";

            // Menangkap error validasi Laravel (422)
            if (error.response && error.response.status === 422) {
                const errors = error.response.data.errors;
                // Ambil pesan error pertama yang ditemukan
                errorMessage = Object.values(errors)[0][0];
            } else if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }

            alert(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalWraper
            isOpen={openModal} 
            setIsOpen={setOpenModal}
            title={<h3 className="text-white">Hubungkan Perangkat Baru</h3>}
            icon={<FaWhatsapp className="text-cyan-500 text-xl" />}
        >
            <form onSubmit={handleAddDevice} className="space-y-5">
                
                {/* --- Toggle Primary (Lebih Estetik) --- */}
                <div className="flex items-center justify-between p-3 bg-slate-800/30 rounded-xl border border-slate-700/30">
                    <div className="flex flex-col">
                        <span className="text-sm font-bold text-slate-200">Jadikan Utama (Primary)</span>
                        <span className="text-[10px] text-slate-500">Hanya satu perangkat yang bisa primary</span>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={deviceForm.primary}
                            onChange={(e) => setDeviceForm({ ...deviceForm, primary: e.target.checked })}
                        />
                        <div className="w-11 h-6 bg-slate-700 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-cyan-500/30 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-cyan-600 shadow-inner"></div>
                    </label>
                </div>

                {/* --- Input Nama --- */}
                <div>
                    <label className="block text-xs font-bold text-slate-400 mb-1.5 uppercase tracking-wider">
                        Nama Perangkat
                    </label>
                    <input
                        type="text"
                        required
                        value={deviceForm.name}
                        onChange={(e) => setDeviceForm({ ...deviceForm, name: e.target.value })}
                        className="w-full px-4 py-3 rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 outline-none transition-all"
                        placeholder="Contoh: HP Sales 1"
                    />
                </div>

                {/* --- Input Nomor HP --- */}
                <div>
                    <label className="block text-xs font-bold text-slate-400 mb-1.5 uppercase tracking-wider">
                        Nomor WhatsApp
                    </label>
                    <input
                        type="tel"
                        required
                        minLength={8}
                        value={deviceForm.phone_number}
                        onChange={(e) => setDeviceForm({ ...deviceForm, phone_number: e.target.value })}
                        className="w-full px-4 py-3 rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 outline-none transition-all font-mono"
                        placeholder="0812... atau 62812..."
                    />
                    <p className="text-[10px] text-slate-500 mt-1">*Backend akan otomatis menyesuaikan format nomor (contoh: 08xx menjadi 628xx)</p>
                </div>

                {/* --- Action Button --- */}
                {loading ? (
                    <div className="flex items-center justify-center py-3 gap-2 text-cyan-400 font-medium">
                        <div className="animate-spin w-5 h-5 border-2 border-cyan-500 border-t-transparent rounded-full"></div>
                        <span>Memproses...</span>
                    </div>
                ) : (
                    <button
                        type="submit"
                        className="w-full py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 text-white font-bold transition-all shadow-lg shadow-cyan-600/25 flex items-center justify-center gap-2 active:scale-[0.98]"
                    >
                        <FaPlus className="text-sm" /> Hubungkan Perangkat
                    </button>
                )}
            </form>
        </ModalWraper>
    );
};